import React from 'react';
import { Box, Tooltip, Typography } from '@mui/material';
import { lightColours, darkColours } from '../../../../styles/colours';

// Utility function to handle dark mode styling
const getBoxStyles = (darkMode) => ({
  backgroundColor: darkMode ? "#333" : lightColours.lightGrey, 
  border: 'none', 
  position: "relative",
  transition: "background-color 0.3s ease",
});

// National Insurance Bar Component
const NationalInsuranceBar = ({ nationalInsurance, salary, darkMode }) => {
  // Calculate the width percentage of the National Insurance relative to the salary
  const niWidthPercentage = (nationalInsurance / salary) * 100;

  return (<>
            {/* Heading for Tax Brackets */}
            <Typography
            variant="h6"
            sx={{ backgroundColor: 'white', pt:1, pb:1, textAlign: 'left', fontWeight: 'bold', color: darkMode ? '#fff' : '#222' }}
            >
            National Insurance
            </Typography>
    <Box sx={{ display: "flex", width: "100%", height: 30, ...getBoxStyles(darkMode) }}>
      {/* Tooltip to show National Insurance info */}
      <Tooltip title={`National Insurance: £${nationalInsurance.toLocaleString(undefined, {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                        })}`} arrow>
        <Box
          sx={{
            backgroundColor: darkColours.darkPink, // National Insurance bar color
            width: `${niWidthPercentage}%`, // Width based on NI percentage
            height: "100%",
            position: "absolute",
            top: 0,
            left: 0,
            boxSizing: "border-box",
            border: 'none',
            transition: "border-color 0.3s ease",
          }}
        />
      </Tooltip>
    </Box></>
  );
};

export default NationalInsuranceBar;